/* istanbul ignore file */
export class Constants {
	public static readonly CLIENT_ACTION = 'clientAction';
	public static readonly URL_PARAM_SCOPE_SET = 'sap-px-scopeSet';
	public static readonly SCOPE_USER_INITIATED = 'manual';
	public static readonly SCOPE_APP_PUSH = 'appPush';
	public static readonly SCOPE_TIMED_PUSH = 'timedPush';
	public static readonly SCOPE_INSTANT_PUSH = 'instantPush';
	public static readonly URL_PARAM_TEST_MODE = 'sap-px-testMode';
	public static readonly URL_PARAM_DEBUG_MODE = 'sap-px-debug';
	public static readonly URL_PARAM_UI5_DEBUG_MODE = 'sap-ui-debug';
	public static readonly URL_PARAM_STANDALONE_MODE = 'sap-px-standalone';
	public static readonly VALUE_NOT_AVAILABLE = 'N/A';
	public static readonly STOR_PUSH_STATE = 'sap.feedback.ui.pushState';
	public static readonly GENERIC_TRIGGER_AREAID = 'sap.feedback.generic';
	public static readonly CSS_STYLE_TAG_ID = 'sap-px-api-creative-css';
	public static readonly SUPPORTED_MAJOR_CFG_VERSION = 0;
	public static readonly CURRENT_CFG_VERSION = '0.4.0';
	////
	//Logger file names
	////
	public static readonly FILE_APP_CONTEXT_DATA_CONTAINER = 'api.data.AppContextDataContainer';
	public static readonly FILE_USER_STATE = 'api.data.UserState';
	public static readonly FILE_PX_API = 'api.PxApi';
	public static readonly FILE_PUSH_HANDLER = 'api.config.push.PushHandler';
	public static readonly FILE_PUSH_CFG = 'api.config.push.PushConfig';
	public static readonly FILE_INIT_CONTROLLER = 'api.InitController';
	public static readonly FILE_INSTANT_PUSH_CONTROLLER = 'api.survey.InstantPushController';
	public static readonly FILE_CONTROLLER_PROVIDER = 'api.ControllerProvider';
	public static readonly FILE_CFG_UTIL = 'api.config.ConfigUtil';
	public static readonly FILE_CFG_JSON_PARSER = 'api.config.ConfigJsonParser';
	public static readonly FILE_TIMED_PUSH_CONTROLLER = 'api.survey.TimedPushController';
	public static readonly FILE_VALIDATION_HANDLER = 'api.survey.ValidationHandler';
	public static readonly FILE_CENTRAL_CFG = 'api.config.CentralConfig';
	public static readonly FILE_CFG_LOADER = 'api.config.ConfigurationLoader';
	public static readonly FILE_PUSH_CONTEXT_DATA = 'api.data.PushContextData';
	public static readonly FILE_THEMING = 'api.theming.Theming';
	public static readonly FILE_GENERIC_THEMING = 'api.theming.GenericTheming';
	public static readonly FILE_CSS_THEMING = 'api.theming.CssTheming';

	////
	//LIMITS
	////
	public static LIMITS = class {
		public static readonly MIN_RECOMMENDED_INTERVAL_TIMER_IN_MINUTES = 30;
		public static readonly MIN_RECOMMENDED_MIN_TIME_TO_START_TIME_IN_HRS = 3;
		public static readonly MIN_RECOMMENDED_INTERVAL_INITIAL_PUSH_IN_DAYS = 3;
		public static readonly MIN_RECOMMENDED_DEVIATION_INITIAL_PUSH_IN_DAYS = 1;
		public static readonly MIN_RECOMMENDED_INTERVAL_NEXT_PUSH_IN_DAYS = 3;
		public static readonly MIN_RECOMMENDED_DEVIATION_NEXT_PUSH_IN_DAYS = 1;
		public static readonly MAX_APP_TRIGGERED_PUSH_PAYLOAD_SIZE_IN_CHARS = 250;
		public static readonly MAX_SNOOZE_COUNT = 2;
	};
	////
	//DEFAULTS
	////
	public static DEFAULTS = class {
		public static readonly DAYS_UNTIL_STATE_EXPIRY = 180;
		public static readonly PUSH_GENERAL_QUIET_PERIOD_IN_HRS = 48;
		public static readonly PUSH_GENERAL_SNOOZE_PERIOD_IN_HRS = 25;

		public static readonly TIMED_PUSH_INTERVAL_TIMER_IN_MINS = 30;
		public static readonly TIMED_PUSH_MIN_TIME_TO_START_TIMER_IN_HRS = 12;
		public static readonly TIMED_PUSH_INTERVAL_INIT_PUSH_IN_DAYS = 35;
		public static readonly TIMED_PUSH_DEVIATION_INIT_PUSH_IN_DAYS = 7;
		public static readonly TIMED_PUSH_INTERVAL_NEXT_PUSH_IN_DAYS = 90;
		public static readonly TIMED_PUSH_DEVIATION_NEXT_PUSH_IN_DAYS = 28;

		public static readonly APP_PUSH_INTERVAL_INIT_PUSH_IN_DAYS = 14;
		public static readonly APP_PUSH_DEVIATION_INIT_PUSH_IN_DAYS = 7;
		public static readonly APP_PUSH_INTERVAL_NEXT_PUSH_IN_DAYS = 45;
		public static readonly APP_PUSH_DEVIATION_NEXT_PUSH_IN_DAYS = 7;
	};

	////
	//DEVICE
	////
	public static DEVICE = class {
		public static readonly TYPE = {
			PHONE: 'phone',
			TABLET: 'tablet',
			DESKTOP: 'desktop'
		};
		public static readonly ORIENTATION = {
			PORTRAIT: 'portrait',
			LANDSCAPE: 'landscape'
		};
		public static readonly OS_NAME = {
			MAC: 'macOS',
			WINDOWS: 'windows'
		};
		public static readonly BROWSER_NAME = {
			CHROME: 'chrome',
			EDGE: 'edge',
			FIREFOX: 'firefox',
			IE: 'internet explorer',
			OPERA: 'opera',
			SAFARI: 'safari'
		};
	};
}
